import { useRef } from "react"
import { Paper, Button } from "@mui/material"
import { useReactToPrint } from "react-to-print"
import OrderReceipt from "src/modules/invoices/thermal/order-receipt"
import { ReceiptTemplateType } from "src/graphql/quark/quark.type"
import { useTypedSelector } from "src/shared/store/store"

// Interfaces for data
interface ItemData {
  name?: string
  quantity?: number
  unitPrice?: number
  discount?: number
  taxRate?: number
  taxExclusive?: number
  taxAmount?: number
  total?: number
  beforeDiscount?: number
  skuCode?: string
}

interface ReceiptDataProps {
  orderNumber?: string
  companyName?: string
  websiteUrl?: string
  locationName?: string
  locationAddress?: string
  orderDate?: string
  orderType?: string
  commercialId?: string
  registerName?: string
  cashierName?: string
  customerName?: string
  customerPhone?: string
  customerEmail?: string
  customerAddress?: string
  customerTaxNo?: string
  customerCommercialNo?: string
  items?: ItemData[]
  subtotal?: number
  totalDiscount?: number
  productDiscount?: number
  orderDiscount?: number
  cardDiscount?: number
  tax?: number
  shippingFee?: number
  platformFee?: number
  integrationFee?: number
  total?: number
  paymentMethod?: string
  transactionNumber?: string
  specialInstructions?: string
  mrNo?: string
  integrationPartnerInvoice?: string
}

const sampleReceiptData: ReceiptDataProps = {
  orderNumber: "1234",
  companyName: "Acme Pharmacy",
  websiteUrl: "www.acmepharmacy.com",
  locationName: "Main Branch",
  locationAddress: "123 Main St, City",
  orderDate: new Date().toLocaleDateString(),
  orderType: "Regular",
  customerName: "John Doe",
  customerPhone: "123-456-7890",
  items: [
    {
      name: "Panadol 500 mg 1 x 20 S",
      quantity: 2,
      unitPrice: 100,
      total: 200,
      discount: 40,
      taxExclusive: 208.69,
      taxRate: 15,
      taxAmount: 31.3,
      beforeDiscount: 240.0,
      skuCode: "PAN500"
    },
    {
      name: "Arinac 500 mg 1 x 20 S",
      quantity: 3,
      unitPrice: 90,
      total: 270,
      discount: 30,
      taxExclusive: 260.86,
      taxRate: 15,
      taxAmount: 39.13,
      beforeDiscount: 300.0,
      skuCode: "ARI500"
    },
    {
      name: "Panadol 500 mg 1 x 20 S",
      quantity: 2,
      unitPrice: 100,
      total: 200,
      discount: 40,
      taxExclusive: 208.69,
      taxRate: 15,
      taxAmount: 31.3,
      beforeDiscount: 240.0,
      skuCode: "PAN500"
    },
    {
      name: "Arinac 500 mg 1 x 20 S",
      quantity: 3,
      unitPrice: 90,
      total: 270,
      discount: 30,
      taxExclusive: 260.86,
      taxRate: 15,
      taxAmount: 39.13,
      beforeDiscount: 300.0,
      skuCode: "ARI500"
    }
  ],
  subtotal: 469.56,
  totalDiscount: 70.0,
  productDiscount: 70.0,
  tax: 70.43,
  shippingFee: 100,
  integrationFee: 1,
  total: 571.0,
  paymentMethod: "POS terminal (Bank Name)",
  transactionNumber: "1234567890"
}
// Main Receipt Component
const OrderReceiptTemplate2Example = () => {
  const tenant = useTypedSelector((state) => state?.authentication?.tenant)
  const componentRef = useRef<HTMLDivElement>(null)

  // Handle print functionality with proper page setup
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    pageStyle: `
      @page {
        size: 80mm auto;
        margin: 0mm;
      }
      @media print {
        body {
          margin: 0;
          padding: 0;
        }
        * {
          box-sizing: border-box;
        }
      }
    `
  })

  // Helper function to check if a section has any content
  // const hasContent = (obj: Record<string, any> | undefined): boolean => {
  //   if (!obj) return false
  //   return Object.values(obj).some(
  //     (val) =>
  //       val !== undefined &&
  //       val !== null &&
  //       val !== "" &&
  //       (typeof val !== "object" || (Array.isArray(val) && val.length > 0))
  //   )
  // }

  // Calculate total quantity

  return (
    <>
      <Button variant="contained" color="primary" onClick={() => handlePrint()} sx={{ mb: 2 }}>
        Print Receipt
      </Button>

      <Paper elevation={2} sx={{ maxWidth: "90mm", mx: "auto" }}>
        <OrderReceipt
          receiptType={ReceiptTemplateType.Template_2}
          receiptRef={componentRef}
          receiptData={{ ...sampleReceiptData, logo: tenant?.invertedLogo as string }}
        />
      </Paper>
    </>
  )
}

export default OrderReceiptTemplate2Example
